import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"
import { CSSProperties } from "react"

export const card: SxProps<Theme> = {
  display: "grid",
  gridAutoFlow: "row",
  backgroundColor: "var(--Schemes-Surface)",
  fontFamily: "Roboto, sans-serif",
  color: "var(--secondary-text)",
  padding: "8px 8px 16px 8px",
  gap: "8px",
  borderRadius: "16px",
  border: "1px solid var(--Schemes-Outline-Variant)",
  boxShadow: "0px 2px 4px 0px #00000014",
  gridTemplate: "auto 1fr minmax(36px, auto) / 1fr",
  boxSizing: "border-box",
  overflowX: "hidden",
}

export const cardImg: SxProps<Theme> = {
  position: "relative",
  padding: "0px 0px 51% 0px",
  borderRadius: "8px",
  backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  img: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}

export const cardContent: SxProps<Theme> = {
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  paddingBottom: "8px",
}

export const cardQrButton: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  borderRadius: "16px",
  padding: "16px 8px 14px 8px",
  background: "var(--Schemes-Surface-Container-Highest)",
  boxShadow: "none",
  '&: hover': {
    background: "var(--Schemes-Surface-Container-Highest)",
    cursor: "auto",
    boxShadow: "none",
  }
}

export const cardQrButtonText: CSSProperties = {
  backgroundColor: "var(--Schemes-Error)",
  color: "#fff",
  fontFamily: "Roboto, sans-serif",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "24px",
  letterSpacing: "0.15px",
  minWidth: "160px",
  minHeight: "48px",
  gap: "8px",
  opacity: "0.8",
  padding: "12px 16px",
  borderRadius: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
}

